<template>
    <div>
        <!-- Unsaved Changes Dialog -->
        <v-dialog v-model="showDialog" max-width="400" persistent>
            <v-card>
                <v-card-title class="headline">Unsaved Changes</v-card-title>
                <v-card-text> Are you sure you want to leave this page? Any unsaved changes will be lost. </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn text @click="handleConfirmation(false)">Stay</v-btn>
                    <v-btn color="primary" @click="handleConfirmation(true)">Leave</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </div>
</template>

<script>
//must be used with the unsavedChangesMixin
export default {
    name: "UnsavedChecker",
    props: {
        hasUnsavedChanges: {
            type: Boolean,
            default: false,
        },
        skipBeforeUnload: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            showDialog: false,
            navigationGuard: null,
        };
    },
    created() {
        // Add the event listener when component is created
        window.addEventListener("beforeunload", this.handleBeforeUnload);
    },
    beforeDestroy() {
        // Remove the event listener when component is destroyed
        window.removeEventListener("beforeunload", this.handleBeforeUnload);
    },
    methods: {
        /**
         * Handle browser-level navigation (close tab, refresh, etc.)
         */
        handleBeforeUnload(event) {
            // Skip warning if explicitly disabled (e.g., during programmatic reload after seeding)
            if (this.skipBeforeUnload) return;

            // Only show warning if there are unsaved changes and dialog is not already visible
            // If dialog is visible, it means we're already handling navigation via Vue Router
            if (this.hasUnsavedChanges && !this.showDialog) {
                // The message set here isn't actually displayed in most modern browsers
                // for security reasons, but setting it is required to show the dialog
                const message = "You have unsaved changes. Are you sure you want to leave?";
                event.returnValue = message; // Standard for most browsers
                return message; // For older browsers
            }
        },
        /**
         * Intercept Vue Router navigation
         * Call this method from beforeRouteLeave or beforeRouteUpdate
         * @param {Function} next - The next() callback from the route guard
         */
        interceptNavigation(next) {
            if (this.hasUnsavedChanges) {
                this.showDialog = true;
                this.navigationGuard = next;
            } else {
                next();
            }
        },
        /**
         * Handle user's confirmation choice in the dialog
         * @param {Boolean} confirmed - Whether user confirmed to leave
         */
        handleConfirmation(confirmed) {
            this.showDialog = false;
            const next = this.navigationGuard;
            this.navigationGuard = null;
            if (next) {
                confirmed ? next() : next(false);
            }
        },
    },
};
</script>

<style scoped></style>
